import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  IconButton,
  Center,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  HStack,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  Text,
  ModalFooter,
  Tooltip,
  Select,
  useToast,
  Skeleton,
  SkeletonText,
  Box
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import {
  addJobTitlesAsync,
  deleteJobTitleAsync,
  fetchJobTitlesAsync,
  selectJobTitles,
  updateJobTitleAsync,
} from "../../../JobPostingSlice/JobTitles/JobTitlesSlice";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";

function JobTitlesList() {
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const dispatch = useDispatch();
  const jobTitles = useSelector(selectJobTitles);
  const [newJobTitle, setNewJobTitle] = useState("");
  const [newJobStatus, setNewJobStatus] = useState("");
  const [error, setError] = useState(null);
  const [editJobTitle, setEditJobTitle] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobTitle, setEditableJobTitle] = useState(null);
  const [deletingJob, setDeletingJob] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const loadData = async () => {
      try {
        await dispatch(fetchJobTitlesAsync());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        showErrorToast("Failed to load job titles");
      }
    };
    loadData();
  }, [dispatch]);

  const showSuccessToast = (message) => {
    toast({
      title: "Success",
      description: message,
      status: "success",
      duration: 3000,
      isClosable: true,
      position: "top-right",
    });
  };

  const showErrorToast = (message) => {
    toast({
      title: "Error",
      description: message,
      status: "error",
      duration: 3000,
      isClosable: true,
      position: "top-right",
    });
  };

  const handleDelete = async (uuid) => {
    try {
      await dispatch(deleteJobTitleAsync(uuid));
      dispatch(fetchJobTitlesAsync());
      onClose2();
      showSuccessToast("Job title deleted successfully");
    } catch (error) {
      showErrorToast("Failed to delete job title");
    }
  };

  const openDeleteModal = (job) => {
    setDeletingJob(job);
    dispatch(fetchJobTitlesAsync());
    onOpen2();
  };

  const handleSave = async () => {
    if (!newJobTitle.trim()) {
      setError("Job title cannot be empty");
      return;
    }

    if (!newJobStatus) {
      setError("Status cannot be empty");
      return;
    }

    const jobTitle = {
      title: newJobTitle,
      status: newJobStatus,
    };

    try {
      await dispatch(addJobTitlesAsync(jobTitle));
      dispatch(fetchJobTitlesAsync());
      setNewJobTitle("");
      setNewJobStatus("");
      onClose1();
      showSuccessToast("Job title added successfully");
    } catch (err) {
      setError(err.message);
      showErrorToast("Failed to add job title");
    }
  };

  const handleEdit = (jobTitle) => {
    setEditableJobTitle(jobTitle);
    setEditJobTitle(jobTitle.title);
    setEditJobStatus(jobTitle.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (!editJobTitle.trim()) {
      setError("Job title cannot be empty");
      return;
    }

    if (!editJobStatus) {
      setError("Status cannot be empty");
      return;
    }

    try {
      await dispatch(
        updateJobTitleAsync({
          uuid: editableJobTitle.uuid,
          title: editJobTitle,
          status: editJobStatus,
        })
      );

      await dispatch(fetchJobTitlesAsync());
      setEditableJobTitle(null);
      setEditJobTitle("");
      setEditJobStatus("");
      setIsEditModalOpen(false);
      showSuccessToast("Job title updated successfully");
    } catch (err) {
      setError(err.message);
      showErrorToast("Failed to update job title");
    }
  };

  return (
    <div
      className="min-h-screen bg-adminbg contentAdmin p-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="">
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Job Type
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add Job Title
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSave();
                    }}
                  >
                    <ModalBody py={6}>
                      <VStack spacing={6}>
                        <Grid
                          templateColumns="repeat(2, 1fr)"
                          gap={4}
                          width="100%"
                        >
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Title</FormLabel>
                              <Input
                                className="  "
                                color="black"
                                placeholder="Enter job title"
                                value={newJobTitle}
                                onChange={(e) => setNewJobTitle(e.target.value)}
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Status</FormLabel>
                              <Select
                                placeholder="Select job status"
                                value={newJobStatus}
                                onChange={(e) => setNewJobStatus(e.target.value)}
                                borderColor="black"
                                color="black"
                              >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </Grid>
                        {error && <Text color="red.500">{error}</Text>}
                      </VStack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="md">
                      <Button colorScheme="blue" mr={3} type="submit">
                        Save
                      </Button>
                      <Button onClick={onClose1}>Cancel</Button>
                    </ModalFooter>
                  </form>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                size="4xl"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit Job Title
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleUpdate();
                    }}
                  >
                    <ModalBody py={6}>
                      <VStack spacing={6}>
                        <Grid
                          templateColumns="repeat(2, 1fr)"
                          gap={4}
                          width="100%"
                        >
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Title</FormLabel>
                              <Input
                                className="  "
                                color="black"
                                placeholder="Enter job title"
                                value={editJobTitle}
                                onChange={(e) =>
                                  setEditJobTitle(e.target.value)
                                }
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Status</FormLabel>
                              <Select
                                placeholder="Select job status"
                                value={editJobStatus}
                                onChange={(e) => setEditJobStatus(e.target.value)}
                                borderColor="black"
                                color="black"
                              >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </Grid>
                        {error && <Text color="red.500">{error}</Text>}
                      </VStack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="md">
                      <Button colorScheme="blue" mr={3} type="submit">
                        Update
                      </Button>
                      <Button onClick={() => setIsEditModalOpen(false)}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </form>
                </ModalContent>
              </Modal>
              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                  <ModalHeader
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Confirm Deletion
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Text fontSize="md" textAlign="center">
                      Are you sure you want to delete{" "}
                      <Text as="span" fontWeight="semibold" color="red.500">
                        "{deletingJob?.title}"
                      </Text>
                      ?
                    </Text>
                  </ModalBody>
                  <ModalFooter display="flex" gap={"2"} justifyContent="center">
                    <Button
                      colorScheme="red"
                      w="40"
                      onClick={() => handleDelete(deletingJob.uuid)}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outline"
                      colorScheme="red"
                      w="40"
                      onClick={onClose2}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">S.No</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {isLoading ? (
                  // Show skeleton loading when data is loading
                  Array.from({ length: 5 }).map((_, index) => (
                    <Tr key={index}>
                      <Td>
                        <Skeleton height="20px" />
                      </Td>
                      <Td>
                        <Skeleton height="20px" />
                      </Td>
                      <Td>
                        <Skeleton height="20px" />
                      </Td>
                      <Td>
                        <HStack spacing={2}>
                          <Skeleton height="20px" width="20px" />
                          <Skeleton height="20px" width="20px" />
                        </HStack>
                      </Td>
                    </Tr>
                  ))
                ) : Array.isArray(jobTitles) && jobTitles.length > 0 ? (
                  [...jobTitles]
                    .sort((a, b) => a.uuid - b.uuid)
                    .map((job, index) => (
                      <Tr key={job?.uuid}>
                        <Td>{index + 1}</Td>
                        <Td>{job?.title}</Td>
                        <Td textColor={job?.status === "active" ? "green" : "red"}>
                          {job?.status}
                        </Td>
                        <Td>
                          <HStack spacing={2}>
                            <Tooltip label="Edit" aria-label="Edit">
                              <IconButton
                                aria-label="Edit"
                                icon={<EditIcon />}
                                colorScheme="blue"
                                size="sm"
                                onClick={() => handleEdit(job)}
                              />
                            </Tooltip>
                            <Tooltip label="Delete" aria-label="Delete">
                              <IconButton
                                aria-label="Delete"
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => openDeleteModal(job)}
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobTitlesList;